import React from 'react';
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import { convertToSnakeCase, getImageSrc } from '../Util/CommonUtils';
import '../../../../src/stylesheets/responsiveGridStyles.scss';

const HomeHero = (props) => {
  return (
    <div className="homeHeroContainer container-center-lg">
      <div className="margin-main-section">
        <h1 className="heroHeading">{props.heading}</h1>
        <div className="row">
          <div className="col-lg-3 col-sm-6 col-xs-12 hero-image-wrap">
            <picture>
                  <source
                    className="hero-image"
                    height={props.ImageHeight ? props.ImageHeight : 'auto'}
                    width={props.ImageWidth ? props.ImageWidth : 'auto'}
                    alt={props.imageAlt}
                    srcset={getImageSrc(props?.ImageSrcOptimized)}
                    type="image/webp"
                  />
                  <img
                    className="hero-image"
                    height={props.ImageHeight ? props.ImageHeight : 'auto'}
                    width={props.ImageWidth ? props.ImageWidth : 'auto'}
                    alt={props.imageAlt}
                    src={getImageSrc(props.image)}
                  />
                </picture>
          </div>
          <div className="col-lg-7 col-sm-6 col-xs-12 hero-features-wrap">
            <div className="features-in-hero font-size-19px">
              <ul className="features">
                {props.features.map((feature, index) => {
                  return <li key={index}>{feature}</li>;
                })}
              </ul>
              <div className="getStartedWithTopProduct">
                <Link to={props.getStartedLink}>{props.getStartedText}</Link>
              </div>
              <div className="shopAllChecks">
                <Link to={props.otherProductsLink}>{props.otherProductsText}</Link>
              </div>
            </div>
          </div>
        </div>
        <div className="text-align-center reorderFromHome">
          <h3>
            {props.reorderText}
            &nbsp;
            <a
              onClick={() => props.signInClicked()}
              data-wa-link={props.reorderLinkText}
              data-ui-object="link"
              data-refer-ui-access-point={`reorder_link_text | ${convertToSnakeCase(
                props.reorderLinkText,
              )}`}
            >
              {props.reorderLinkText}
            </a>
          </h3>
        </div>
      </div>
    </div>
  );
};

HomeHero.propTypes = {
  heading: PropTypes.string,
  image: PropTypes.string,
  imageAlt: PropTypes.string,
  features: PropTypes.array,
  getStartedLink: PropTypes.string,
  getStartedText: PropTypes.string,
  otherProductsLink: PropTypes.string,
  otherProductsText: PropTypes.string,
};

export default HomeHero;
